import script from "./UI.vue?vue&type=script&setup=true&lang=js"
export * from "./UI.vue?vue&type=script&setup=true&lang=js"

import "./UI.vue?vue&type=style&index=0&id=e0dd7650&lang=scss&scoped=true"
import "./UI.vue?vue&type=style&index=1&id=e0dd7650&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0dd7650"]])

export default __exports__